<template>
  <section class="co-page full-screen">
    <header class="head">
      <div>
        <p class="co-eyebrow">Operações · Tuk-tuk</p>
        <h1 class="co-title">Pedidos Coreanos</h1>
      </div>
      <div class="head-actions">
        <router-link :to="{ name: 'coreanos-new' }" class="co-btn is-lime new-btn" aria-label="Novo pedido">
          <b-icon icon="plus" size="is-small" /><span>Novo pedido</span>
        </router-link>
         <button type="button" class="icon-btn" title="Configurações" aria-label="Configurações" @click="openSettings">
          <b-icon icon="cog" size="is-small" />
        </button>
      </div>
    </header>

    <!-- Configurações: the Telegram groups and options (own overlay, as in CoreanosDetail) -->
    <div v-if="showSettings" ref="settingsOverlay" class="settings-overlay" tabindex="-1" @click.self="showSettings = false" @keydown.esc="showSettings = false">
      <div class="co-card settings-card" role="dialog" aria-modal="true">
        <div class="settings-head">
          <h2>Configurações</h2>
          <button type="button" class="link" @click="showSettings = false">Fechar</button>
        </div>
    <div v-if="telegram && settingRole" class="co-card telegram">
      <div>
        <p class="tg-title">
          <b-icon icon="paper-plane" size="is-small" />{{
            settingRole === "admins"
              ? "Ligar o grupo dos admins (alertas)"
              : settingRole === "test"
                ? "Ligar o grupo de testes"
                : "Ligar o grupo dos guias"
          }}
        </p>
        <ol>
          <li>
            No Telegram, adiciona
            <strong>@{{ telegram.bot || "GuidersPTBot" }}</strong> ao grupo
            {{
              settingRole === "admins"
                ? "da equipa"
                : settingRole === "test"
                  ? "de testes (só para ti; cria um grupo novo no Telegram)"
                  : "dos guias"
            }}.
          </li>
          <li>
            Clica em "Procurar grupos" e escolhe o grupo. O bot envia lá uma
            mensagem de teste.
          </li>
        </ol>
        <p v-if="telegram.groupsError" class="small error">
          {{ telegram.groupsError }}
        </p>
      </div>
      <div class="tg-actions">
        <button
          v-for="g in telegram.groups"
          :key="g.id"
          type="button"
          class="co-btn is-lime is-small"
          :disabled="tgBusy"
          @click="useGroup(g)"
        >
          Usar "{{ g.title }}"
        </button>
        <button
          type="button"
          class="co-btn is-small"
          :disabled="tgBusy"
          @click="loadTelegram"
        >
          {{ tgBusy ? "A procurar…" : "Procurar grupos" }}
        </button>
        <button
          v-if="telegram.chat"
          type="button"
          class="co-btn is-small"
          @click="manualRole = null"
        >
          Cancelar
        </button>
      </div>
    </div>
    <div v-if="telegram && telegram.chat" class="tg-lines">
      <p class="tg-line">
        <b-icon icon="paper-plane" size="is-small" />Grupo dos guias:
        <span class="tg-name">{{
          telegram.chat.title || telegram.chat.id
        }}</span>
        <button type="button" class="link" @click="manualRole = 'guides'">
          Mudar
        </button>
      </p>
      <p class="tg-line">
        <b-icon icon="bell" size="is-small" />Alertas para a equipa:
        <span class="tg-name">{{
          telegram.adminChat
            ? telegram.adminChat.title || telegram.adminChat.id
            : "por email (sem grupo)"
        }}</span>
        <button type="button" class="link" @click="manualRole = 'admins'">
          {{ telegram.adminChat ? "Mudar" : "Ligar grupo" }}
        </button>
      </p>
      <p class="tg-line">
        <b-icon icon="hand-pointer" size="is-small" />Respostas por botão no Telegram:
        <span class="tg-name">{{ telegram.webhookOn ? "ativas" : "desligadas" }}</span>
        <button v-if="!telegram.webhookOn" type="button" class="link" :disabled="tgBusy" @click="enableButtons">Ativar</button>
      </p>
      <p class="tg-line">
        <b-icon icon="thumbtack" size="is-small" />Mensagem afixada «Esta semana»:
        <span class="tg-name">{{ telegram.weekOn ? "ligada" : "desligada" }}</span>
        <button type="button" class="link" :disabled="tgBusy" @click="toggleWeek">{{ telegram.weekOn ? "Desligar" : "Ligar" }}</button>
      </p>
      <p class="tg-line">
        <span class="tg-test">🧪</span>Tours de teste:
        <span class="tg-name">{{
          telegram.testChat
            ? telegram.testChat.title || telegram.testChat.id
            : "sem grupo (as mensagens de teste não são enviadas)"
        }}</span>
        <button type="button" class="link" @click="manualRole = 'test'">
          {{ telegram.testChat ? "Mudar" : "Ligar grupo" }}
        </button>
      </p>
    </div>
      </div>
    </div>

    <div class="stats">
      <div class="stat">
        <span class="stat-label">Próximos 7 dias</span>
        <span class="stat-value">{{ week.length }} <small>tour{{ week.length === 1 ? "" : "s" }}</small></span>
      </div>
      <div class="stat" :class="{ 'is-alert': missing.tuks }">
        <span class="stat-label">Tuk-tuks em falta</span>
        <span class="stat-value">{{ missing.tuks }}<small v-if="missing.tuks"> em {{ missing.tours }} tour{{ missing.tours === 1 ? "" : "s" }}</small></span>
      </div>
      <div class="stat" :class="{ 'is-live': selecting.length }">
        <span class="stat-label">Em seleção</span>
        <span class="stat-value">{{ selecting.length }}<small v-if="selecting.length"> · {{ minutesUntil(selecting[0].selectionClosesAt) }} min</small></span>
      </div>
      <div v-if="notReconfirmed" class="stat is-alert">
        <span class="stat-label">Por reconfirmar</span>
        <span class="stat-value">{{ notReconfirmed }}</span>
      </div>
    </div>

    <div class="toolbar">
      <div class="chips" role="tablist">
        <button
          v-for="f in filters"
          :key="f.id"
          type="button"
          role="tab"
          :aria-selected="filter === f.id"
          :class="{ 'is-active': filter === f.id }"
          @click="filter = f.id"
        >
          {{ f.label }}<span v-if="f.count" class="count">{{ f.count }}</span>
        </button>
      </div>
      <label class="search">
        <b-icon icon="search" size="is-small" />
        <input v-model.trim="search" type="search" placeholder="Pesquisar local, data, telefone…" />
      </label>
    </div>

    <div v-if="loading" class="loading">
      <b-loading :is-full-page="false" :active="true" />
    </div>
    <p v-else-if="error" class="empty">{{ error }}</p>
    <div v-else-if="!rows.length" class="empty">
      <b-icon icon="calendar" />
      <p>{{ search ? "Nenhum pedido encontrado." : "Sem pedidos aqui." }}</p>
    </div>
    <template v-else>
      <section v-for="d in days" :key="d.date" class="day">
        <h2 class="day-head">
          <strong v-if="d.label">{{ d.label }}</strong>{{ dayLabel(d.date) }}
          <span class="day-count">{{ d.items.length }}</span>
        </h2>
        <div class="tours">
          <router-link
            v-for="r in d.items"
            :key="r.id"
            :to="{ name: 'coreanos-detail', params: { id: r.id } }"
            class="tour"
            :class="`is-${statusOf(r).key}`"
          >
            <div class="tour-top">
              <span class="tour-time">{{ r.startTime }}</span>
              <span v-if="r.isTest" class="test-tag">Teste</span>
              <span class="co-badge" :class="`is-${statusOf(r).key}`">{{ statusOf(r).label }}</span>
            </div>

            <ol class="route">
              <li>
                <span class="pin"></span>
                <span class="route-text"><small>Pick-up</small>{{ r.pickup && r.pickup.label }}</span>
              </li>
              <li>
                <span class="pin is-end"></span>
                <span class="route-text"><small>Drop-off</small>{{ r.dropoff ? r.dropoff.label : "Sem drop-off" }}</span>
              </li>
            </ol>

            <div class="tour-foot">
              <span class="seats" aria-hidden="true">
                <i v-for="(on, n) in seats(r)" :key="n" :class="{ on }"></i>
              </span>
              <span class="seats-text"><strong>{{ (r.counts && r.counts.assigned) || 0 }}/{{ r.tuksTotal }}</strong> tuk-tuks</span>
              <span v-if="statusOf(r).note || sixLabel(r)" class="tour-note">{{ statusOf(r).note || sixLabel(r) }}</span>
            </div>
          </router-link>
        </div>
      </section>
    </template>
  </section>
</template>

<script>
import {
  watchTourRequests,
  getTelegram,
  useTelegramGroup,
  enableTelegramButtons,
  setTelegramWeekMessage,
  dayLabel,
  statusOf,
  minutesUntil,
  toDate,
  tuksLabel,
} from "@/services/coreanos";

const DAY = 24 * 3600 * 1000;

export default {
  name: "CoreanosList",
  metaInfo: { title: "Pedidos Coreanos | Admin" },
  data() {
    return {
      telegram: null,
      tgBusy: false,
      manualRole: null,
      showSettings: false,
      requests: [],
      loading: true,
      error: "",
      filter: "upcoming",
      search: "",
      now: Date.now(),
    };
  },
  computed: {
    // Which Telegram group is being set up now (guides first, then admins)
    settingRole() {
      if (!this.telegram) return null;
      if (this.manualRole) return this.manualRole;
      return this.telegram.chat ? null : "guides";
    },
    open() {
      return this.requests.filter(
        (r) =>
          !["cancelled", "completed"].includes(r.status) &&
          !["done"].includes(statusOf(r, this.now).key),
      );
    },
    week() {
      return this.open.filter(
        (r) => r.status !== "draft" && toDate(r.startAt) - this.now < 7 * DAY,
      );
    },
    weekTuks() {
      return this.week.reduce((sum, r) => sum + (r.tuksTotal || 0), 0);
    },
    missing() {
      const short = this.open.filter(
        (r) => r.status !== "draft" && ((r.counts && r.counts.open) || 0) > 0,
      );
      return {
        tours: short.length,
        tuks: short.reduce((sum, r) => sum + r.counts.open, 0),
      };
    },
    selecting() {
      return this.open
        .filter((r) => statusOf(r, this.now).key === "selecting")
        .sort(
          (a, b) => toDate(a.selectionClosesAt) - toDate(b.selectionClosesAt),
        );
    },
    notReconfirmed() {
      return this.open.reduce(
        (sum, r) => sum + ((r.counts && r.counts.notReconfirmed) || 0),
        0,
      );
    },
    groups() {
      const key = (r) => statusOf(r, this.now).key;
      return {
        upcoming: this.open,
        searching: this.open.filter(
          (r) => key(r) === "searching" || key(r) === "selecting",
        ),
        full: this.open.filter((r) => key(r) === "full" || key(r) === "warn"),
        draft: this.open.filter((r) => r.status === "draft"),
        done: this.requests.filter((r) => key(r) === "done").reverse(),
        cancelled: this.requests
          .filter((r) => r.status === "cancelled")
          .reverse(),
      };
    },
    filters() {
      const g = this.groups;
      return [
        { id: "upcoming", label: "Próximos", count: g.upcoming.length },
        { id: "searching", label: "À procura", count: g.searching.length },
        { id: "full", label: "Completos", count: g.full.length },
        { id: "draft", label: "Rascunhos", count: g.draft.length },
        { id: "done", label: "Concluídos" },
        { id: "cancelled", label: "Cancelados" },
      ];
    },
    // The visible rows, one block per day (same order as the rows)
    days() {
      const days = [];
      this.rows.forEach((r) => {
        const last = days[days.length - 1];
        if (last && last.date === r.date) last.items.push(r);
        else days.push({ date: r.date, label: this.relativeDay(r.date), items: [r] });
      });
      return days;
    },
    rows() {
      const q = this.search.toLowerCase();
      if (!q) return this.groups[this.filter];
      return this.groups[this.filter].filter((r) =>
        [
          r.pickup && r.pickup.label,
          r.dropoff && r.dropoff.label,
          dayLabel(r.date),
          r.date,
          r.startTime,
          r.shortId,
          r.clientWhatsapp,
        ]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q)),
      );
    },
  },
  mounted() {
    this.loadTelegram();
    this.timer = setInterval(() => (this.now = Date.now()), 30000);
    this.unsubscribe = watchTourRequests(
      (list) => {
        this.requests = list;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = "Não foi possível carregar os pedidos.";
      },
    );
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    tuksLabel,
    dayLabel,
    // Focus the overlay so Esc closes it
    openSettings() {
      this.showSettings = true;
      this.$nextTick(() => this.$refs.settingsOverlay && this.$refs.settingsOverlay.focus());
    },
    async loadTelegram() {
      this.tgBusy = true;
      try {
        this.telegram = await getTelegram();
        // Nothing set up yet: open the settings straight away
        if (!this.telegram.chat && !this.showSettings) this.openSettings();
      } catch (error) {
        this.telegram = {
          bot: null,
          chat: null,
          groups: [],
          groupsError: error.message,
        };
      } finally {
        this.tgBusy = false;
      }
    },
    // Telegram starts sending every tap to the backend (needed for the answer buttons)
    async enableButtons() {
      this.tgBusy = true;
      try {
        await enableTelegramButtons();
        this.$buefy.toast.open({ message: "Respostas por botão ativas.", type: "is-success", position: "is-bottom" });
        await this.loadTelegram();
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, type: "is-danger", duration: 8000, position: "is-bottom" });
      } finally {
        this.tgBusy = false;
      }
    },
    // "Esta semana": publishes and pins it in the guides' group when turned on
    async toggleWeek() {
      const on = !this.telegram.weekOn;
      this.tgBusy = true;
      try {
        await setTelegramWeekMessage(on);
        this.$buefy.toast.open({ message: on ? "«Esta semana» publicada e afixada no grupo." : "«Esta semana» desligada.", type: "is-success", position: "is-bottom" });
        await this.loadTelegram();
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, type: "is-danger", duration: 8000, position: "is-bottom" });
      } finally {
        this.tgBusy = false;
      }
    },
    async useGroup(group) {
      this.tgBusy = true;
      try {
        await useTelegramGroup(group.id, group.title, this.settingRole);
        this.manualRole = null;
        this.$buefy.toast.open({
          message: `Ligado a "${group.title}".`,
          type: "is-success",
          position: "is-bottom",
        });
        await this.loadTelegram();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.message,
          type: "is-danger",
          duration: 8000,
          position: "is-bottom",
        });
        this.tgBusy = false;
      }
    },
    minutesUntil,
    statusOf(r) {
      return statusOf(r, this.now);
    },
    // One dot per tuk-tuk, filled for the ones with a guide
    seats(r) {
      const assigned = (r.counts && r.counts.assigned) || 0;
      return Array.from({ length: Math.min(r.tuksTotal || 0, 12) }, (_, n) => n < assigned);
    },
    relativeDay(date) {
      const lisbon = (t) => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Lisbon" }).format(t);
      if (date === lisbon(this.now)) return "Hoje";
      if (date === lisbon(this.now + DAY)) return "Amanhã";
      return "";
    },
    sixLabel(r) {
      const six = r.tuksSixSeatsRequired || 0;
      return six
        ? `${six} tuk${six === 1 ? "" : "s"} de 6 lugares`
        : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./coreanos";

.test-tag {
  margin-left: 0.5rem;
  padding: 0.0625rem 0.5rem;
  border-radius: 999px;
  background: $warn-bg;
  font-size: 0.75rem;
  font-weight: 500;
  color: $warn-ink;
}

.tg-test {
  margin-right: 0.25rem;
}

// Title on the left, actions on the right (they go under the title only
// when there's no room, e.g. a very narrow phone)
.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 600px) {
    margin-bottom: 1rem;
  }
}

.telegram {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding: 1.125rem 1.375rem;
  border-color: $lime;

  ol {
    margin: 0.5rem 0 0 1.25rem;
    font-size: 0.9375rem;
    color: $ink-sub;
  }

  .error {
    margin-top: 0.5rem;
    color: #a32c1f;
  }
}

.tg-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: $display;
  font-size: 1.125rem;
  font-weight: 600;
  color: $forest;
}

.tg-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.head-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.settings-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(10, 30, 25, 0.55);
  outline: 0;
}

.settings-card {
  width: 100%;
  max-width: 36rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  padding: 1.5rem;
  background: #fff;

  h2 {
    font-family: $display;
    font-size: 1.25rem;
    font-weight: 600;
    color: $forest;
  }

  .link {
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    font-weight: 500;
    color: $forest;
    text-decoration: underline;
    cursor: pointer;
  }
}

.settings-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.tg-lines {
  display: flex;
  flex-direction: column;

  .tg-line {
    margin-bottom: 0.25rem;
  }
}

.tg-name {
  font-weight: 500;
  color: $forest;
}

.tg-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: $ink-sub;

  .link {
    margin-left: 0.5rem;
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    font-weight: 500;
    color: $forest;
    text-decoration: underline;
    cursor: pointer;
  }
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid $line;
  border-radius: 999px;
  background: #fff;
  color: $forest;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: $soft;
  }
}

.new-btn {
  gap: 0.375rem;

  @media (max-width: 600px) {
    min-height: 2.75rem;
    padding: 0 1rem;
    font-size: 0.875rem;
  }
}

// Stats: small tiles side by side (3 or 4), never a half-empty row
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(6.5rem, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.5rem;

  @media (max-width: 600px) {
    gap: 0.5rem;
    margin-bottom: 1rem;

    .stat {
      padding: 0.75rem;
    }

    .stat-value {
      font-size: 1.25rem;
    }
  }
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.875rem 1rem;
  border: 1px solid $line;
  border-radius: 14px;
  background: #fff;

  &.is-alert {
    border-color: $warn-bg;
    background: $warn-soft;

    .stat-value {
      color: $orange;
    }
  }

  &.is-live {
    border-color: $forest;
  }
}

.stat-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: $ink-sub;
}

.stat-value {
  font-family: $display;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.1;
  color: $forest;

  small {
    font-size: 0.8125rem;
    font-weight: 500;
    color: $ink-sub;
  }
}

// Filters (chips that scroll sideways on phones) + search
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.5rem;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 1rem;
  }
}

// Filters wrap; on phones an even 3 × 2 grid that always fits the screen
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    min-width: 0;
    height: 2.25rem;
    padding: 0 0.875rem;
    border: 1px solid $line;
    border-radius: 999px;
    background: #fff;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
    color: $ink-sub;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    @media (max-width: 600px) {
      padding: 0 0.375rem;
      font-size: 0.8125rem;
    }

    &.is-active {
      border-color: $forest;
      background: $forest;
      color: #fff;

      .count {
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
      }
    }
  }

  .count {
    min-width: 1.25rem;
    padding: 0 0.375rem;
    border-radius: 999px;
    background: $soft;
    font-size: 0.75rem;
    text-align: center;
    color: $forest;
  }
}

.search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 17rem;
  max-width: 100%;
  height: 2.5rem;
  padding: 0 0.875rem;
  border: 1px solid $line;
  border-radius: 12px;
  background: #fff;
  color: $ink-faint;

  &:focus-within {
    border-color: $forest;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: 2.75rem;
  }

  input {
    flex: 1;
    min-width: 0;
    border: 0;
    outline: 0;
    background: none;
    font: inherit;
    font-size: 1rem; // 16px: no zoom on iPhone
    color: $ink;
  }
}

.loading {
  position: relative;
  min-height: 10rem;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 3rem 1rem;
  border: 1px dashed $line;
  border-radius: 14px;
  text-align: center;
  color: $ink-faint;
}

// Days
.day {
  margin-bottom: 1.5rem;

  @media (max-width: 600px) {
    margin-bottom: 1rem;
  }
}

.day-head {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0 0 0.5rem;
  font-family: $display;
  font-size: 0.875rem;
  font-weight: 500;
  color: $ink-sub;

  strong {
    margin-right: 0.125rem;
    font-weight: 700;
    color: $forest;
  }
}

.day-count {
  min-width: 1.25rem;
  padding: 0 0.375rem;
  border-radius: 999px;
  background: $soft;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  color: $forest;
}

.tours {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
  gap: 0.75rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}

// Tour card: time + state, the route, then the tuk-tuks
.tour {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  padding: 1rem 1.125rem;
  border: 1px solid $line;
  border-radius: 16px;
  background: #fff;
  color: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: $forest-2;
    box-shadow: 0 4px 16px rgba(10, 30, 25, 0.08);
  }

  &:active {
    transform: scale(0.995);
  }

  &.is-searching,
  &.is-warn {
    border-color: $warn-bg;
    box-shadow: inset 3px 0 0 $orange;
  }

  &.is-selecting {
    box-shadow: inset 3px 0 0 $forest;
  }

  &.is-done,
  &.is-cancelled {
    opacity: 0.65;
  }

  &.is-cancelled .tour-time {
    text-decoration: line-through;
  }
}

.tour-top {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .co-badge {
    margin-left: auto;
  }
}

.tour-time {
  font-family: $display;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.01em;
  color: $forest;
}

.test-tag {
  padding: 0.0625rem 0.5rem;
  border-radius: 999px;
  background: $warn-bg;
  font-size: 0.6875rem;
  font-weight: 600;
  color: $warn-ink;
}

// Pick-up and drop-off joined by a line, as in ride apps
.route {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    display: flex;
    gap: 0.75rem;

    & + li {
      margin-top: 0.5rem;
    }

    &:first-child::after {
      content: "";
      position: absolute;
      top: 0.875rem;
      bottom: -0.625rem;
      left: 0.28rem;
      border-left: 1.5px dashed $line;
    }
  }
}

.pin {
  flex-shrink: 0;
  width: 0.625rem;
  height: 0.625rem;
  margin-top: 0.3rem;
  border: 2px solid $forest;
  border-radius: 999px;
  background: #fff;

  &.is-end {
    border-color: $forest;
    background: $forest;
  }
}

.route-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.3;
  color: $ink;
  overflow-wrap: anywhere;

  small {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $ink-faint;
  }
}

.tour-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.625rem;
  padding-top: 0.75rem;
  border-top: 1px solid $line;
  font-size: 0.8125rem;
  color: $ink-sub;
}

.seats {
  display: flex;
  gap: 0.1875rem;

  i {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 999px;
    background: $line;

    &.on {
      background: $forest-2;
    }
  }
}

.seats-text strong {
  font-weight: 600;
  color: $forest;
}

.tour-note {
  margin-left: auto;
  color: $ink-sub;

  .is-searching &,
  .is-warn & {
    font-weight: 500;
    color: $warn-ink;
  }
}

// Phones: settings open as a bottom sheet
@media (max-width: 768px) {
  .settings-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .settings-card {
    max-width: none;
    max-height: 85vh;
    border-radius: 20px 20px 0 0;
    padding-bottom: calc(1.5rem + env(safe-area-inset-bottom));
  }
}
</style>
